import React, { useEffect } from "react";

import { GoogleAnalyticsFour as Value } from "@reactivated";

export const GoogleAnalyticsFourBlock = (props: {
    id: string;
    value: Value;
    cspNonce: string | null | undefined;
}): React.ReactNode => {
    // In order to be compatible with strict-dynamic mode CSPs, since this
    // is an external script we can't hash, it has to be dynamically inserted
    // like this, not parser-inserted.
    useEffect(() => {
        if (!props.value.container_id) {
            return;
        }
        const gtag = document.createElement("script");
        gtag.src = `https://www.googletagmanager.com/gtag/js?id=${props.value.container_id}`;
        gtag.async = true;
        document.head.appendChild(gtag);
    }, []);

    if (!props.value.container_id) {
        return null;
    }
    const nonce =
        props.cspNonce && typeof window !== "undefined"
            ? ""
            : props.cspNonce || undefined;
    return (
        <script key={`${props.id}-inline`} nonce={nonce}>
            {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());

            gtag('config', '${props.value.container_id}');`}
        </script>
    );
};
